import ExternalLinkRedirect from "../utils/ExternalLinkRedirect";

export default function RequisitosAdmision() {
  return <ExternalLinkRedirect idMenu={387} />;
}
